import icon0 from '../assets/img/icons/icono_antecedentes.png';
import icon1 from '../assets/img/icons/icono_filosofia.png';
import icon2 from '../assets/img/icons/icono_mision_vision.png';
import icon3 from '../assets/img/icons/icono_valores.png';
import icon4 from '../assets/img/icons/icono_organigrama.png';
import icon5 from '../assets/img/icons/icono_normativas.png';
import icon6 from '../assets/img/icons/icono_calendario.png';
import icon7 from '../assets/img/icons/icono_inscripcion.png';

export const InstitucionMenu = [
    {
        id: 1,
        nombre: "Antecedentes",
        icon: icon0,
        font: 14,
        idScroll: "antecedentes"
    },
    {
        id: 2,
        nombre: "Filosofía Institucional",
        icon: icon1,
        font: 14,
        idScroll: "filosofia"
    },
    {
        id: 3,
        nombre: "Misión y Visión",
        icon: icon2,
        font: 14,
        idScroll: "misionVision"
    },
    {
        id: 4,
        nombre: "Valores",
        icon: icon3,
        font: 14,
        idScroll: "valores"
    },
    {
        id: 5,
        nombre: "Organigrama",
        icon: icon4,
        font: 14,
        idScroll: "organigrama"
    },  
    {
        id: 6,
        nombre: "Normativas y Reglamentos",
        icon: icon5,
        font: 14,
        idScroll: "normativas"
    },
    {
        id: 7,
        nombre: "Calendario Académico",
        icon: icon6,
        font: 14,
        idScroll: "calendario"
    }
]

export const IngresoMenu = [
    {
        id: 1,
        nombre: "Inscripción (Admisión)",
        icon: icon7,
        font: 14,
        idScroll: "inscripcion"
    }
]

export const ReingresoMenu = [
    {
        id: 1,
        nombre: "Reinscripción (Regulares)",
        icon: icon7,
        font: 14,
        idScroll: "reinscripcion"
    },
]


// WEBPACK FOOTER //
// ./src/shared/MenuItems.jsx